import React, { FunctionComponent } from "react";
import Routes from "@routes";
import ErrorBoundary from "@components/ErrorBoundary";
import { ToastContainer } from "react-toastify";

const App: FunctionComponent = () => (
  <ErrorBoundary>
    <Routes />
    <ToastContainer position="top-right" autoClose={5000} />
  </ErrorBoundary>
);

export default App;
